import React, { Component } from "react";
import Layout from './Layout/Layout';

import BadgeClassesList from './BadgeClassesList/BadgeClassesList';

class Landing extends Component{

	render(){
		return(
				<Layout>
					<h2>Lista Badges</h2>
					<BadgeClassesList />
				</Layout>
			);
		
	}
}


export default Landing


// WEBPACK FOOTER //
// ./src/components/Frontend/Landing.js